<template >
  <!-- modal -->


  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>

    <div
        style="position: absolute; right: 28vw; width: 51vw; height: auto"
        class="card-panel-main col-lg-9 mb-5 p-2"
    >
      <div v-if="modalActive" class="card card-body card-panel-box border-0">
        <div class="d-flex justify-content-between">
          <h3 style="font-size: 1.1vw !important">تیکت جدید</h3>
          <p @click.prevent="modalActive=false" class="cursor-pointer">❌</p>
        </div>
        <hr>
        <div class="mt-5 row mx-0 g-4" >
        <div class="col-6">
          <label class="text-end mb-3 d-block fw-bold">عنوان درخواست</label>
          <input v-model="title" class="form-control bg-white">
        </div>
        <div class="col-6">
          <label class="text-end mb-3 d-block fw-bold">اولویت تیک</label>
          <select class="form-select bg-white" v-model="priority">
            <option value="" disabled selected>انتخاب کنید</option>
            <option value="low">کم</option>
            <option value="medium">متوسط</option>
            <option value="high">زیاد</option>
          </select>
        </div>
        <div class="col-12">
          <label class="text-end mb-3 d-block fw-bold">توضیحات</label>
          <textarea v-model="description" style="height: 10vw;" rows="17" class="form-control"></textarea>
        </div>
        <div class="col-12 position-relative">
          <label class="text-end mb-3 d-block fw-bold">پیوست فایل</label>
          <span @click.prevent="selectFile" class="position-absolute">انتخاب فایل</span>
          <input ref="fileInput" type="file" class="d-block form-control" @change="handleFileChange" />
          <div v-if="showProgress" class="progress mt-3">
            <div class="progress-bar" role="progressbar" :style="{ width: uploadProgress + '%' }" :aria-valuenow="uploadProgress" aria-valuemin="0" aria-valuemax="100">{{ uploadProgress }}%</div>
          </div>
        </div>
        <div class="col-2 mx-auto">
          <div class="bg-info mainHover rounded-0-4vw d-flex align-items-center justify-content-center gap-01vw text-white fw-bold cursor-pointer py-2 px-3">
            <p @click="submitTicket" class="mb-0">ثبت تیکت</p>
          </div>
        </div>
      </div>
      </div>
      <div v-if="!modalActive" class="card card-body card-panel-box border-0">
        <div class="d-flex align-items-center justify-content-between gap-3">
          <div class="d-flex align-items-start gap-1vw">
            <div class="rounded-circle bg-info w-1vw h-1vw mt-3"></div>
            <div>
              <p class="fw-bold mb-0 fs-1-4vw text-end">لیست تیکت ها</p>
              <p class="text-muted mb-0">سیستم درخواست پشتیبانی تیکت</p>
            </div>
          </div>
          <div v-if="!this.is_mother" @click="toggleModal"
               class="bg-info mainHover rounded-0-4vw d-flex align-items-center justify-content-center gap-01vw text-white fw-bold cursor-pointer py-1 px-3"
          >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="bi bi-plus w-2vw h-2vw d-block"
                viewBox="0 0 16 16"
            >
              <path
                  d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
              />
            </svg>
            <p  class="mb-0">تیکت جدید</p>
          </div>
        </div>
        <div
            class="shadow ticketTab rounded-0-4vw overflow-hidden row mx-0 px-2 py-3 mt-4"
        >
          <div class="col-2 border-l-dash">
            <div class="d-flex align-items-center gap-06vw">
              <div class="rounded-circle flex-shrink-0">
                <img
                    alt="img"
                    :src="require('../../assets/img/Capture_prev_ui.png')"
                    class="w-3vw"
                />
              </div>
              <div>
                <p class="fw-bold mb-0 text-end fs-09vw">همه تیکت ها</p>
                <p class="text-muted mb-0 text-end">
                  <span class="fw-bold text-info">{{all_items.length}}</span> تیکت
                </p>
              </div>
            </div>
          </div>
          <div class="col-2 border-l-dash">
            <div class="d-flex align-items-center gap-06vw">
              <div class="rounded-circle flex-shrink-0">
                <img
                    alt="img"
                    :src="require('../../assets/img/Capture_prev_ui (2).png')"
                    class="w-3vw"
                />
              </div>
              <div>
                <p class="fw-bold mb-0 text-end fs-09vw">منتظر پاسخ شما</p>
                <p class="text-muted mb-0 text-end">
                  <span v-if="this.is_mother" class="text-dark fw-bold">{{items_under_review}}</span>
                  <span v-else class="text-dark fw-bold">{{items_waiting_response}}</span> تیکت
                </p>
              </div>
            </div>
          </div>
          <div class="col-2 border-l-dash">
            <div class="d-flex align-items-center gap-06vw">
              <div class="rounded-circle flex-shrink-0">
                <img
                    alt="img"
                    :src="require('../../assets/img/Capture_prev_ui (3).png')"
                    class="w-3vw"
                />
              </div>
              <div>
                <p class="fw-bold mb-0 text-end fs-09vw">بررسی نشده</p>
                <p class="text-muted mb-0 text-end">
                  <span v-if="this.is_mother" class="text-dark fw-bold">{{items_under_review}}</span>
                  <span v-else class="fw-bold text-dark">{{items_not_reviewed}}</span> تیکت
                </p>
              </div>
            </div>
          </div>
          <div class="col-2 border-l-dash">
            <div class="d-flex align-items-center gap-06vw">
              <div class="rounded-circle flex-shrink-0">
                <img
                    alt="img"
                    :src="require('../../assets/img/Capture_prev_ui (4).png')"
                    class="w-3vw"
                />
              </div>
              <div>
                <p class="fw-bold mb-0 text-end fs-09vw">در حال بررسی</p>
                <p class="text-muted mb-0 text-end">
                  <span class="fw-bold text-dark">{{items_under_review}}</span> تیکت
                </p>
              </div>
            </div>
          </div>
          <div class="col-2 border-l-dash">
            <div class="d-flex align-items-center gap-06vw">
              <div class="rounded-circle flex-shrink-0">
                <img
                    alt="img"
                    :src="require('../../assets/img/Capture_prev_ui (5).png')"
                    class="w-3vw"
                />
              </div>
              <div>
                <p class="fw-bold mb-0 text-end fs-09vw">پاسخ داده شده</p>
                <p class="text-muted mb-0 text-end">
                  <span class="fw-bold text-dark">{{items_answered}}</span> تیکت
                </p>
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="d-flex align-items-center gap-06vw">
              <div class="rounded-circle flex-shrink-0">
                <img
                    alt="img"
                    :src="
                    require('../../assets/img/Capture-fotor-bg-remover-20240623144516.png')
                  "
                    class="w-3vw"
                />
              </div>
              <div>
                <p class="fw-bold mb-0 text-end fs-09vw">بسته شده</p>
                <p class="text-muted mb-0 text-end">
                  <span class="fw-bold text-dark">{{items_closed}}</span> تیکت
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- table -->
        <table class="mt-4 border">
          <tr class="bg-secondary">
            <th class="fw-bold py-2 fs-1vw">وضعیت</th>
            <th class="fw-bold py-2 fs-1vw">شماره تیکت</th>
            <th class="fw-bold py-2 fs-1vw">عنوان</th>
            <th class="fw-bold py-2 fs-1vw">شناسه</th>
            <th class="fw-bold py-2 fs-1vw">اولویت</th>
            <th v-if="this.is_mother" class="fw-bold py-2 fs-1vw">شرکت</th>
            <th class="fw-bold py-2 fs-1vw">آخرین تغییر</th>
            <th class="fw-bold py-2 fs-1vw">عملیات</th>
          </tr>
          <tr class="fs-09vw" v-for="(item,index) in all_items">
            <td class="py-3">
              {{setStatus(item.status)}}
            </td>
            <td class="py-3">{{index+1}}</td>
            <td class="py-3">{{item.title}}  </td>
            <td class="py-3">{{item.code}}</td>
            <td class="py-3">
              <p
                  class="mb-0 fs-09vw bg-green d-inline-block text-success rounded-0-4vw py-1 px-3 mx-auto fw-bold"
              >
                {{setPriority(item.priority)}}
              </p>
            </td>
            <td v-if="this.is_mother" class="py-3">{{item.user_company.company.name}}</td>
            <td class="py-3">{{item.change_date}}</td>
            <td class="py-2 text-info">
              <router-link :to="`/ticket/detail/${item.hash_id}`" class="mb-0 cursor-pointer fw-bold text-decoration-none">جزئیات</router-link>
            </td>
          </tr>



        </table>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import Modal from "@/components/Modal/Modal.vue";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name: "HomeView",
  data() {
    return {
      modalActive:false,
      is_update: false,
      title: '',
      priority: '',
      description: '',
      selectedFile: null,
      uploadProgress: 0,
      showProgress: false,
      all_items: [],
      items_closed: 0,
      items_answered: 0,
      items_under_review: 0,
      items_not_reviewed: 0,
      items_waiting_response: 0,
    };
  },
  components: {
    Modal,
    Reset,
    Sidebar,
    splash,
  },
  methods: {
    setPriority(item){
      if (item==='low'){
        return 'کم'
      }else if (item==='medium'){
        return 'متوسط'

      }else{
        return 'زیاد'

      }
    },setStatus(item){
      if (item==='closed'){
        return 'بسته شده'
      }else if (item==='answered'){
        return ' پاسخ داده شده'

      }else if (item==='under_review'){
        return 'در حال بررسی'

      }else if (item==='not_reviewed'){
        return 'بررسی نشده'

      }else if (item==='waiting_response'){
        return 'منتظر پاسخ شما'

      }
    },
    selectFile() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    submitTicket() {
      if (!this.title){
        toast.error('عنوان اجباری است!')
      }else if (!this.priority){
        toast.error('اولویت اجباری است!')
      }else if (!this.description){
        toast.error('توضیحات اجباری است!')
      }


      const formData = new FormData();
      if (this.selectedFile) {
        formData.append('file', this.selectedFile);

      }
      formData.append('title', this.title);
      formData.append('description', this.description);
      formData.append('priority', this.priority);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${this.base_url}/Tickets/store`, true);
      xhr.setRequestHeader('Authorization', `Bearer ${this.$cookies.get('token')}`);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          this.uploadProgress = Math.round((event.loaded / event.total) * 100);
          this.showProgress = true;
        }
      };

      xhr.onload = () => {
        if (xhr.response.error){
          toast.error(xhr.response.error)
          return;
        }
        if (xhr.status === 200) {
          toast.success('تیکت شما با موفقیت ثبت شد!');
          // Reset progress bar and form
          this.uploadProgress = 0;
          this.showProgress = false;
          this.title = '';
          this.priority = '';
          this.description = '';
          this.selectedFile = null;
          this.$refs.fileInput.value = null;
          this.modalActive = false
          this.all()
        } else {
          toast.success('خطایی رخ داده است');
        }
      };

      xhr.onerror = () => {
        toast.error('خطایی در ارسال فایل رخ داده است');
      };

      xhr.send(formData);
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push("/mother_items");
        return;
      }
    },
    toggleModal() {
      this.modalActive = !this.modalActive;
    },
    all() {
      fetch(`${this.base_url}/Tickets`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({}),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.data){
              this.all_items = [...response.data]
            }
            if (response.items_closed) {
              this.items_closed=response.items_closed
            };
            if (response.items_answered) {
              this.items_answered = response.items_answered
            };
            if (response.items_under_review) {
              this.items_under_review=response.items_under_review
            };
            if (response.items_not_reviewed) {
              this.items_not_reviewed=response.items_not_reviewed
            };
            if (response.items_waiting_response) {
              this.items_waiting_response = response.items_waiting_response
            };


          }).catch((err) => {
      })
    },
  },
  mounted() {
    this.all()
  }
};
</script>
<style scoped lang="scss">
.fade-enter-active,.fade-leave-active{
  transition: opacity 0.6s;
}
.fade-enter-from,.fade-leave-to{
  opacity: 0;
}
a {
  font-size: 1vw;
}
.card:not(:last-child) {
  height: 12vw;
}
.btn-submit-1 {
  width: 18vw !important;
}
/*.line_after{
    position: relative;
    &::after{
      position: absolute;
      width: 0.01vw;
      height: 53vw;
      content: '';
      background-color: #efecf3 !important;
      top: 5vw;
      right: 35.3vw ;
      border-radius: 1vw;
    }
  }*/
p {
  font-size: 1vw;
}
.position-absolute{
  right: 1.5vw;
  background-color: #fff;
  top: 2.7vw;
  cursor: pointer;
  font-size: 1vw;
}
img:hover{
  filter: unset;
  cursor: pointer;
}
</style>